
/* BEARE PARK – Collection View More */

(() => {
  async function loadMore(button) {
    const pagination = button.closest('[data-bp-pagination]');
    const products = pagination?.closest('[data-products-grid]');
    const grid = products?.querySelector('.js-grid');

    if (!pagination || !grid || button.disabled) return;

    const nextUrl = pagination.dataset.nextUrl;
    if (!nextUrl) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Loading';

    try {
      const url = new URL(nextUrl, window.location.href);
      if (url.origin !== window.location.origin) {
        throw new Error('Invalid collection URL');
      }

      const response = await fetch(url.toString(), {
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error('Unable to load products');
      }

      const html = await response.text();
      const documentNext = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const nextGrid = documentNext.querySelector(
        '[data-products-grid] .js-grid'
      );

      const nextPagination = documentNext.querySelector(
        '[data-products-grid] [data-bp-pagination]'
      );

      if (!nextGrid || !nextPagination) {
        throw new Error('Next product page not found');
      }

      const newItems = Array.from(nextGrid.children);

      newItems.forEach((item) => {
        grid.appendChild(document.importNode(item, true));
      });

      pagination.dataset.nextUrl =
        nextPagination.dataset.nextUrl || '';

      button.hidden = !pagination.dataset.nextUrl;

      const nextCollection = pagination.querySelector(
        '[data-bp-next-collection]'
      );

      if (nextCollection) {
        nextCollection.hidden = !!pagination.dataset.nextUrl;
      }

      /* Signal that new product cards have been inserted */
      document.dispatchEvent(
        new CustomEvent('bp:collection-products-added', {
          detail: { grid, items: newItems }
        })
      );

    } catch (error) {
      console.error('BEARE PARK View More:', error);
      button.textContent = 'Try Again';
    } finally {
      button.disabled = false;

      if (button.textContent !== 'Try Again') {
        button.textContent = originalText;
      }
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bp-view-more]');
    if (!button) return;

    event.preventDefault();
    loadMore(button);
  });
})();
